import { render, staticRenderFns } from "./BackgroundPattern.vue?vue&type=template&id=235fd5c4"
import script from "./BackgroundPattern.vue?vue&type=script&lang=js"
export * from "./BackgroundPattern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports